/**
 * Avaliações públicas do perfil da Fidexa no Google (Perfil da Empresa,
 * Limeira/SP), copiadas em 2026-10-15 com o texto exatamente como o autor
 * escreveu. Para atualizar: abra GOOGLE_REVIEWS_URL, ordene por "Mais
 * relevantes" e substitua aqui; a nota e o total ficam em GOOGLE_RATING.
 *
 * Não vira JSON-LD de `Review`/`aggregateRating`: o Google não aceita avaliação
 * autodeclarada em Organization, e a prova fica no link para o perfil.
 */
export type GoogleReview = {
  author: string;
  /** Como aparece no Google ("3 meses atrás"), sem converter para data. */
  when: string;
  text: string;
};

export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?q=fidexa#lrd=0x94c881c556979865:0x61d6180e3ac204ae,1";

export const GOOGLE_RATING = {
  value: "4,9",
  count: 34,
  checkedAt: "2026-10-15",
} as const;

export const GOOGLE_REVIEWS: GoogleReview[] = [
  {
    author: "Isabele Reis",
    when: "4 meses atrás",
    text: "A equipe é atenciosa, o suporte é ágil e os resultados aparecem na prática, com mais controle financeiro e eficiência na gestão. Recomendo para empresas que buscam profissionalizar e otimizar suas cobranças.",
  },
  {
    author: "Silvana Oliveira",
    when: "3 meses atrás",
    text: "Empresa inovadora e competente! Atendimento nota 1.000.",
  },
  {
    author: "Marcio Ramo Silva",
    when: "4 meses atrás",
    text: "Atendimento e suporte excelentes, sem dúvidas a melhor ferramenta que utilizamos no processo de cobrança!",
  },
  {
    author: "Skala Modas Pirapora MG",
    when: "3 meses atrás",
    text: "Muito bom o programa, estamos gostando de usar, está nos ajudando muito das cobranças.",
  },
  {
    author: "Agro Ferramentas",
    when: "3 meses atrás",
    text: "Ferramenta excelente para te ajudar nas cobranças de crediário. Uso e recomendo.",
  },
  {
    author: "Ótica Pupila",
    when: "3 meses atrás",
    text: "Excelente custo-benefício e atendimento impecável. Recomendo a todos!",
  },
];
